import LocalStorageUtils from '../../../util/LocalStorageUtils'

export const problems = [
  {
    id: 109,
    name: '#109. Curtain',
    path: 'https://cssbattle.dev/targets/109.png',
    colors: ['#191919', '#F6E59C'],
  },
  {
    id: 110,
    name: '#110. Sunrays',
    path: 'https://cssbattle.dev/targets/110.png',
    colors: ['#D25B70', '#F6E59C'],
  },
  {
    id: 111,
    name: '#111. Rain Drops',
    path: 'https://cssbattle.dev/targets/111.png',
    colors: ['#F3AC3C', '#254241'],
  },
  {
    id: 112,
    name: '#112. Chevron',
    path: 'https://cssbattle.dev/targets/112.png',
    colors: ['#6592CF', '#293D7E'],
  },
  {
    id: 113,
    name: '#113. Black Light',
    path: 'https://cssbattle.dev/targets/113.png',
    colors: ['#5776F6', '#191919'],
  },
  {
    id: 114,
    name: '#114. Neagtive Box',
    path: 'https://cssbattle.dev/targets/114.png',
    colors: ['#172D2C', '#E9AF53'],
  },
  {
    id: 115,
    name: '#115. Droplet',
    path: 'https://cssbattle.dev/targets/115.png',
    colors: ['#C36271', '#F2E09F'],
  },
  {
    id: 116,
    name: '#116. Headphones',
    path: 'https://cssbattle.dev/targets/116.png',
    colors: ['#293D7E', '#6E91CA'],
  },
]
export const getStartTime = LocalStorageUtils.getItem('darkmode')
export const getExpiredTime = getStartTime + parseInt(LocalStorageUtils.getItem('darkhorse')) * 1000
